<template>
  <div data-component-group="panels" data-component="status-select">
    <v-menu
      v-model="isMenuOpen"
      :close-on-content-click="false"
      :disabled="isDisabled"
    >
      <template #activator="{ props }">
        <span v-bind="props">
          <span :class="statusCircleStyle" />
          <span :class="statusNameStyle">
            {{ item.role.status.name }}
          </span>
          <v-icon v-if="!isDisabled" :class="statusArrowStyle"> keyboard_arrow_down </v-icon>
        </span>
      </template>

      <v-list class="menu-wrapper">
        <v-list-item
          v-for="status in statuses"
          :key="status.name"
          class="menu-item"
          @click="onStatusSelect(item, status)"
        >
          <v-list-item-title :class="getMenuItemTitleStyle(item, status)">
            <span :class="status.class" />
            {{ status.name }}
          </v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
  </div>
</template>

<script>
  export default {
    props: {
      item: {
        type: Object,
        required: true,
      },
      updateItems: {
        type: Function,
        required: false,
      },
    },
    data() {
      return {
        isLoading: false,
        isMenuOpen: false,
      };
    },
    computed: {
      activeUser() {
        return this.$store.getters['auth/user'];
      },
      statuses() {
        return this.$store.getters['businessUsers/statuses'];
      },
      canUpdateStatus() {
        return this.$ability.can('update-status', 'business-members');
      },
      isActiveUser() {
        return this.activeUser.id === this.item.id;
      },
      isDisabled() {
        return this.isActiveUser || !this.canUpdateStatus || this.isLoading;
      },
      statusCircleStyle() {
        return this.item.role.status.id ? 'success-status' : 'error-status';
      },
      statusNameStyle() {
        return !this.isDisabled ? 'status-enabled' : 'status-disabled';
      },
      statusArrowStyle() {
        return !this.isDisabled ? 'menu-icon status-enabled' : 'menu-icon status-disabled';
      },
    },
    methods: {
      setBusinessUserSettings(query) {
        this.isLoading = true;

        return this.$store
          .dispatch('businessUsers/setSettings', query)
          .then((res) => {
            this.isLoading = false;
            this.updateItems();
            return res;
          })
          .catch((err) => {
            this.isLoading = false;
            return err;
          });
      },
      onStatusSelect(item, status) {
        this.isMenuOpen = false;
        const { id, business, role } = item;

        if (item.role.status.id === status.id) {
          return null;
        }

        const query = {
          user: id,
          business_id: business.id,
          status: status.id,
          role: role.slug,
          setting: 'status',
        };

        this.setBusinessUserSettings(query);
      },
      getMenuItemTitleStyle(item, status) {
        return item.role.status.id === status.id
          ? 'menu-item-title-active'
          : 'menu-item-title';
      },
    },
  };
</script>

<style lang="scss">
.menu-wrapper {
  padding: 0;

  .menu-item {
    padding-inline: 0 !important;
    padding: 0;
    min-height: 0;
    cursor: pointer;

    .success-status {
      margin: 0 2px 1px 0;
      width: 8px;
      height: 8px;
      border-radius: 50%;
      display: inline-block;
      background-color: #4caf50;
    }

    .error-status {
      margin: 0 2px 1px 0;
      width: 8px;
      height: 8px;
      border-radius: 50%;
      display: inline-block;
      background-color: #f44336;
    }

    .menu-item-title {
      padding: 12px 24px 12px 8px;
      font-size: 14px;
      color: #424242;
      background-color: white;
    }

    .menu-item-title-active {
      padding: 12px 24px 12px 8px;
      font-size: 14px;
      color: #fb8c00;
      background-color: #fff1e6;
    }
  }
}

[data-component-group='panels'][data-component='status-select'] {
  font-size: 14px;
  font-weight: 500;

  .menu-icon {
    margin: 0 0 2px 12px;
    width: 12px;
  }

  .status-enabled {
    color: #424242;
  }

  .status-disabled {
    color: #9e9e9e;
  }

  .success-status {
    margin: 0 2px 1px 0;
    width: 8px;
    height: 8px;
    border-radius: 50%;
    display: inline-block;
    background-color: #4caf50;
  }

  .error-status {
    margin: 0 2px 1px 0;
    width: 8px;
    height: 8px;
    border-radius: 50%;
    display: inline-block;
    background-color: #f44336;
  }
}
</style>
